import React, { useState } from 'react';
import './styles.scss';
import i18next from 'i18next';
import { iSspProviderContext } from '../../../utils/SspProvider/interfaces.ts';

interface ILanguageProps {
    languages: Array<string>;
    store: iSspProviderContext;
}
export default function LanguageSwitch({
    languages,
}: ILanguageProps): React.ReactElement {
    const { language } = i18next;

    const [GermanActive, setGermanActive] = useState(language === 'de-DE');
    const [EnglishActive, setEnglishActive] = useState(language === 'en-US');

    const handleClick = async () => {
        const newLanguage = i18next.language === 'de-DE' ? 'en-US' : 'de-DE';

        await i18next.changeLanguage(newLanguage);

        setGermanActive(newLanguage === 'de-DE');
        setEnglishActive(newLanguage === 'en-US');
    };

    return (
        <div className='language-switch'>
            {languages.length > 1 && (
                <>
                    <button
                        type='button'
                        className={`${GermanActive ? 'active' : ''}`}
                        onClick={() => handleClick()}
                    >
                        DE
                    </button>
                    <p> | </p>
                    <button
                        type='button'
                        className={`${EnglishActive ? 'active' : ''}`}
                        onClick={() => handleClick()}
                    >
                        EN
                    </button>
                </>
            )}
        </div>
    );
}
